import React from 'react';
import { ActivePageHeading } from './ActivePageHeading';

export function IntroPageContent({
  introOverviewText,
  setIntroOverviewText,
  introWelcomeText,
  setIntroWelcomeText,
  introAfterSectionsText,
  setIntroAfterSectionsText,
  reviewSectionTitle,
  setReviewSectionTitle,
  reviewSectionDescription,
  setReviewSectionDescription,
  introStartButtonText,
  setIntroStartButtonText,
  autoSubmitEnabled,
  setAutoSubmitEnabled,
  introTimerText,
  setIntroTimerText,
  pageNumber,
}) {
  return (
            <div className="space-y-4">
              <ActivePageHeading
                number={pageNumber}
                title="Einführungsseite"
                meta="Willkommen, Timer, Start-Button"
              />
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                  Text vor der Abschnittsliste (optional)
                </label>
                <textarea
                  value={introOverviewText}
                  onChange={(e) => setIntroOverviewText(e.target.value)}
                  rows="3"
                  placeholder="Optional"
                  className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                />
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                  Dieser Text wird im Bewerber-Formular oberhalb der Abschnittsliste angezeigt. Wenn leer, bleibt der Bereich leer.
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                  Überschrift der Abschnittsliste
                </label>
                <input
                  type="text"
                  value={introWelcomeText}
                  onChange={(e) => setIntroWelcomeText(e.target.value)}
                  placeholder="z.B. Dieser Fragebogen besteht aus mehreren Teilen:"
                  className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                />
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                  Diese Überschrift steht direkt über der Liste mit den folgenden Seiten/Abschnitten.
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                  Text nach der Abschnittsliste (optional)
                </label>
                <textarea
                  value={introAfterSectionsText}
                  onChange={(e) => setIntroAfterSectionsText(e.target.value)}
                  rows="3"
                  placeholder="Optional"
                  className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                />
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                  Dieser Text wird im Bewerber-Formular unterhalb der Abschnittsliste angezeigt. Wenn leer, bleibt der Bereich leer.
                </p>
              </div>
              <div className="space-y-2">
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
                  Überprüfung Titel
                </label>
                <input
                  type="text"
                  value={reviewSectionTitle}
                  onChange={(e) => setReviewSectionTitle(e.target.value)}
                  placeholder="Optional"
                  className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                />
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
                  Überprüfung Beschreibung
                </label>
                <textarea
                  value={reviewSectionDescription}
                  onChange={(e) => setReviewSectionDescription(e.target.value)}
                  rows="2"
                  placeholder="Optional"
                  className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                  Start-Button Text
                </label>
                <input
                  type="text"
                  value={introStartButtonText}
                  onChange={(e) => setIntroStartButtonText(e.target.value)}
                  placeholder="Starten"
                  className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                />
              </div>
              <div>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={autoSubmitEnabled}
                    onChange={(e) => setAutoSubmitEnabled(e.target.checked)}
                    className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                    Auto-Submit nach 15 Minuten aktivieren
                  </span>
                </label>
              </div>
              {autoSubmitEnabled && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                    Timer-Hinweis
                  </label>
                  <textarea
                    value={introTimerText}
                    onChange={(e) => setIntroTimerText(e.target.value)}
                    rows="3"
                    className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg focus:ring-2 focus:ring-green-500 text-base"
                  />
                </div>
              )}
            </div>
  );
}
